import "./index.css";
import { useDispatch } from "react-redux";
import axios from "axios";
import React, { useState, useEffect } from "react";
import DateView from "../../components/DateView/dateView";
import SearchView from "../../components/SearchView/searchView";
import MedicineOrderList from "./MedicineOrderList";
import moment from "moment";
import DropDownService from "../../components/DropDownService";
import http from "../../../src/Redux/services/http-common.jsx";
import { ToastContainer, toast } from "react-toastify";
import {
  getBusinessEvent,
  getOrderDetails,
  onAddComment,
  updatePreferTime,
} from "../../Redux/Actions/dashboardaction";

import InfiniteScroll from "react-infinite-scroll-component";

import { onConvertJsonToExcel } from "../../utils/JsonToExcelConverter";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

const SmartLabReports = () => {
  const dispatch = useDispatch();
  const [isSelectedOption] = useState("Smart Lab Reports");

  const [fromDate, setFromDate] = useState(
    moment().add(-1, "days").format("DD-MM-yyyy")
  );
  const [toDate, setToDate] = useState(
    moment().add("days").format("DD-MM-yyyy")
  );
  const [isLoader, setLoader] = useState(false);
  const [pageStart, setPageStart] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const [translatedapi, setTranslatedapi] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [patientCode, setPatientCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); 



  useEffect(() => {

    fetchList();
  }, [statusFilter]);
  console.log(statusFilter,"drftgyhu")
  const fetchList = (pageNo = 1, pageSizeVal = pageSize) => {
    

    const params = new URLSearchParams();
    if (firstName.trim()) params.append("firstName", firstName);
    if (email.trim()) params.append("email", email);
    if (patientCode.trim()) params.append("patientCode", patientCode);
    if (mobileNumber.trim()) params.append("mobileNumber", mobileNumber);
    if (statusFilter != null && statusFilter !== "") {
      params.append("isVerified", statusFilter);
    }
    
    params.append("pageSize", pageSizeVal);
    params.append("pageNumber", pageNo);
  
    const queryString = params.toString();
  
    http
      .get(
        `${
          process.env.REACT_APP_BASEURL
        }backoffice/patientDocument/list/filter${
          queryString ? `?${queryString}` : ""
        }`
      )
      .then((response) => {
        if (response.data.length > 0) {
          setTranslatedapi(response.data);
          setTotalItems(response.data[0]?.totalSize || 0);
        } else {
          setTranslatedapi([]);
          setTotalItems(0);
        }
      })
      .catch((error) => console.log(error));
  };
  
  
  
  const [translatedPres] = useState([
    "Patient Details",
    "Mobile Number",
    "Created Date",
    "Status",
    "Documend Id",
    "Action",
  ]);

  const handlePagination = (newPage) => {
    setPageStart(newPage);
    fetchList(newPage, pageSize);
  };


  



  return (
    <>
      <ToastContainer />
      <div className="profilepage-breadcrumb"></div>

      <div className="titleBusinessEvent"> Select Filters & Services:</div>


<div className="" style={{ display: "flex",marginTop:"15px",  }}>
  
  <div className="" style={{ padding: "0 10px" }}>
    <span className="p-float-label">
      <InputText
        id="patientCode"
        value={patientCode}
        onChange={(e) => setPatientCode(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && fetchList()}
        className="p-inputtext-sm"
      />
      <label htmlFor="patientCode">Patient Code</label>
    </span>
  </div>

 
  <div className="" style={{ padding: "0 10px" }}>
    <span className="p-float-label">
      <InputText
        id="mobileNumber"
        value={mobileNumber}
        onChange={(e) => setMobileNumber(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && fetchList()}
        className="p-inputtext-sm"
      />
      <label htmlFor="mobileNumber">Mobile Number</label>
    </span>
  </div>


  <div className="" style={{ padding: "0 10px" }}>
    <span className="p-float-label">
      <InputText
        id="firstName"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && fetchList()}
        className="p-inputtext-sm"
      />
      <label htmlFor="firstName">First Name</label>
    </span>
  </div>

  <div className="" style={{ padding: "0 10px" }}>
  <Dropdown
  value={statusFilter}
  onChange={(e) => {
    setStatusFilter(e.value);
    setPageStart(1);
 
  }}
  options={[
    { label: "Pending", value: "0" },  
    { label: "Accepted", value: "1" }, 
    { label: "Rejected", value: "2" },  
  ]}
  placeholder="Select Status"
  className="p-inputtext-sm"
  style={{ width: "100%" }}
/>
</div>




  <div className="" style={{ padding: "0 10px" }}>
    <Button
      label="Search"
      icon="pi pi-search"
      className="p-button-sm p-button-primary"
      onClick={() => fetchList()}
      style={{ width: "100%" }}
    />
  </div>
</div>


      <div
        id="scrollableDiv"
        className="listNewContainer"
        style={{
          height: 800,
          overflow: "auto",
        }}
      >
<div
  id="scrollableDiv"
  className="listNewContainer"
  style={{
    height: "auto", 
    overflow: "auto",
  }}
>
  <MedicineOrderList
    medicineList={translatedapi}
    doctorConsultation={translatedPres}
    isLoader={isLoader}
    fetchList={fetchList}
  />

  {/* Pagination Buttons */}
  <div className="pagination-controls" style={{ marginTop: "20px", textAlign: "center" }}>
    <button
      disabled={pageStart === 1}
      onClick={() => handlePagination(pageStart - 1)}
      style={{ marginRight: "10px" }}
    >
      Previous
    </button>

    <span style={{ margin: "0 10px" }}>
      Page {pageStart} of {Math.ceil(totalItems / pageSize)}
    </span>

    <button
      disabled={pageStart >= Math.ceil(totalItems / pageSize)}
      onClick={() => handlePagination(pageStart + 1)}
      style={{ marginLeft: "10px" }}
    >
      Next
    </button>
  </div>
</div>
      </div>
    </>
  );
};

export default SmartLabReports;
